import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e153ffa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "demo-type" }
const _hoisted_2 = { class: "theme-list" }

import { ref,reactive } from 'vue'
import { useDark } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const drawer = ref(false)
//使用useDark 
const isDark = useDark()
//主题配置
const themeConfig = reactive({
  isDark: isDark,
});

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_avatar, {
                      size: 50,
                      src: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
                    })
                  ])
                ]),
                _createVNode(_component_el_col, { span: 1 }),
                _createElementVNode("div", {
                  class: "icon",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = true))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-gear",
                    size: "1x"
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_drawer, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawer).value = $event)),
      title: "I am the title",
      "with-header": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, [
            _createTextVNode("亮色"),
            _createVNode(_component_el_divider, { direction: "vertical" }),
            _createTextVNode("暗黑")
          ]),
          _createVNode(_component_el_switch, {
            modelValue: themeConfig.isDark,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((themeConfig.isDark) = $event)),
            "inline-prompt": "",
            "active-icon": "Sunny",
            "inactive-icon": "Moon"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})